import axios from 'axios'

import { 
	isValidFile,
} from 'utils'

import {
	AUTH_ERROR,
	FILE_VERSION_DELETED,
} from './types'

import { API_URL } from '../api'
import copy from 'fast-copy'

// Update after auth is refactored
import { errorHandler } from './actions'

export function createFiles(files, callback, progressCallback = null, errorCallback = null) {
	let formData = new FormData()

	files.forEach(file => {
		let fileObject = {
			currentVersion: file.currentVersion,
			name: file.title,
			user_id: file.user.id
		}

		// a lot of the below can maybe just be spread, in retrospect.
		if(file.task){
			fileObject.task_id = file.task.id
		}

		if(file.file_id){
			fileObject.file_id = file.file_id
		}

		if(file.project_id){
			fileObject.project_id = file.project_id
		}

		fileObject.chat_id = file.chat_id ? file.chat_id : null

		fileObject.uploaded_to_task = !!file.uploaded_to_task
		fileObject.file_folder_id = file.file_folder_id ? file.file_folder_id : null

		if(file.is_new){
			fileObject.is_new = file.is_new
		}else{
			fileObject.is_new = false
		}

		formData.append('files[]', file.object)
		formData.append('fileData[]', JSON.stringify(fileObject))
	})

	return dispatch => {
		axios
		.post(API_URL + '/files', formData, {
			headers: { 'content-type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
                const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                if (totalLength !== null) {
					let percentComplete = Math.round( (progressEvent.loaded * 100) / totalLength )
					
                	if(progressCallback){
                		progressCallback(percentComplete);
                	}else{
                		console.log('no progress callback');
                	}
                    //this.updateProgressBarValue();
                }
			},
		})
		.then(response => {
			response.data.forEach(file => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: file,
					entityType: 'file',
				})

				if(file && file.latestVersion && file.latestVersion.chat_id){
					dispatch({
						type: 'ENTITY_ADDED_OR_UPDATED',
						payload: {
							id: file.latestVersion.chat_id,
							versions: [file.latestVersion]
						},
						entityType: 'chat',
					})
				}
			})

			callback()
		})
		.catch(error => {
			if(errorCallback){
				errorCallback(error)
			}
			console.log(error)
			errorHandler(dispatch, error.response, AUTH_ERROR)
		})
	}
}

export function deleteFile(file, callback = null) {
	return dispatch => {
		dispatch({
			type: 'ENTITY_DELETED',
			entityType: 'file',
			parentType: 'project',
			payload: file,
		})

		axios.delete(API_URL + `/files/${file.id}`,{})
		.then(response => {
			if (callback) {
				callback()
			}
		})
		.catch(error => {
			console.log(error)
		})
	}
}

export function deleteFileVersion(fileId, versionId, callback) {
	return dispatch => {
		axios
		.delete(API_URL + `/files/${fileId}/versions/${versionId}`,{})
		.then(response => {
			dispatch({
				type: FILE_VERSION_DELETED,
				payload: {
					file: response.data.file,
					versionId
				}
			})

			if (typeof callback !== 'undefined') {
				callback()
			}
		})
		.catch(error => {
			console.log(error)
		})
	}
}

export function updateFile(file){
	return dispatch => {
		axios.post(API_URL+'/files/update', { file })

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: file,
			entityType: 'file',
		})
	}
}

export function updateFileParent(file, newTaskId){
	return dispatch => {
		axios.post(API_URL+'/files/updateParent', {file, task_id: newTaskId})

		const _file = copy(file)

		_file.task_id = newTaskId

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: _file,
			entityType: 'file',
		})
	}
}

export function getFiles(project_id, callback){
	return dispatch => {
		axios.get(API_URL + `/files?project_id=`+project_id)
		.then(response => {
			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data,
				entityType: 'project',
			})

			if(callback){
				callback()
			}
		})
		.catch(error => {
			console.log(error)
			errorHandler(dispatch, error.response, AUTH_ERROR)
		})
	}
}

export function getZipOfFiles(projectId, fileFolderId, callback){
	return dispatch => {
		axios.post(API_URL + `/files/getZip`, { fileFolderId, projectId } )
		.then(response => {
			const downloadLink = document.createElement('a')
			downloadLink.href = API_URL+response.data
			downloadLink.click()
			
			if(callback){
				callback()
			}
		})
		.catch(error => {
			console.log(error)
			errorHandler(dispatch, error.response, AUTH_ERROR)
		})
	}
}

export const openPreviewModal = (versions, startIndex) => {
	return dispatch => {
		dispatch({
			type: 'PREVIEW_MODAL_OPENED',
			payload: {
				versions,
				startIndex
			}
		})
	}
}

export const setFileFolder = (fileId, folderId) => {
	return dispatch => {
		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				id: fileId,
				file_folder_id: folderId
			},
			entityType: 'file',
		})

		axios.post(API_URL+'/files/setFileFolder', { fileId, folderId })
			.catch(error => {
				console.log(error)
			})
	}
}

export const setFolderParent = (folderId, parentId) => {
	return dispatch => {
		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				id:  parseInt(folderId),
				file_folder_id: parentId
			},
			entityType: 'file_folder',
		})

		axios.post(API_URL+'/files/setFolderParent', { folderId, parentId })
			.catch(error => {
				console.log(error)
			})
	}

}


// WEBPACK FOOTER //
// ./src/state/actions/file-actions.jsx